import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql, Link } from "gatsby";
import Slider from "react-slick"
import ResourceCard from '../cards/resourceCard';
import '../../sass/components/flexibleModules/_components.allRelatedResourcesComponent.scss';
import "../../sass/components/_components.latestPosts.scss"
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"

const AllRelatedResourcesComponent = ({ indItem }) => {

    const data = useStaticQuery(graphql`
    {
        allWordpressResource(limit: 10) {
            edges {
              node {
                databaseId
                id
                title
                excerpt
                nodeType
                date(formatString: "DD MMM YYYY")
                slug
                featuredImage {
                  node {
                    altText
                    gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                  }
                }
                whitePapersAndEbooks {
                  resourceType
                  resourceDate
                  podcastUrl
                }
              }
            }
        }
    }
  `)
    // Using state to render after component is mounted, as SLick is causing issues without responsive versions
    const [isRendered, setIsRendered] = useState(false)

    let settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: true,
        centerMode: true,
        centerPadding: "100px 0 0",
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    centerPadding: "10px 0 0",
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "10px 0 0",
                },
            },
        ],
    }

    useEffect(() => {
        setIsRendered(true)
    }, [])

    return (
        <div className="cp-allRelatedReourcesComponent" style={{ backgroundColor: `${indItem.backgroundColor}` }}>
            <div className="cp-allRelatedReourcesComponent__inner" style={{ maxWidth: `${indItem.maxWidth ? (indItem.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                <div className="cp-latestPosts">
                    <div className="cp-latestPosts__inner">
                        <div className="cp-latestPosts__top l--flex">
                            <div className="l--left">
                                {process.env.GATSBY_LANG === "de" ?
                                    <h2>Verwandte Ressourcen</h2>
                                    :
                                    <h2>Related Resources</h2>
                                }
                            </div>
                            <div className="l--right l--desktop">
                                <div className="l-relativeButton">
                                    {process.env.GATSBY_LANG === "de" ?
                                        <>
                                            <Link to="/resources" className="l-button">
                                                Alle Ressourcen ansehen
                                            </Link>
                                            <Link to="/resources" className="l-button l-backgroundHover">
                                                Alle Ressourcen ansehen
                                            </Link>
                                        </>
                                        :
                                        <>
                                            <Link to="/resources" className="l-button">
                                                View All Resources
                                            </Link>
                                            <Link to="/resources" className="l-button l-backgroundHover">
                                                View All Resources
                                            </Link>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="cp-latestPosts__bottom">
                            {isRendered && (
                                <Slider {...settings}>
                                    {data.allWordpressResource.edges.map((resourceItemCheck, index) => (
                                        <React.Fragment key={index}>
                                            <>
                                                {resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'ebook' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources/ebook`} external="no" /> :
                                                    resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'podcast' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={resourceItemCheck.node.whitePapersAndEbooks.podcastUrl} external="yes" /> :
                                                        resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'whitepaper' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources/white-papers`} external="no" /> :
                                                            resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'marketing' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources/marketing`} external="no" /> :
                                                                resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'analystreport' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources/analyst-reports`} external="no" /> :
                                                                    resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'infographics' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources/guide`} external="no" /> :
                                                                        resourceItemCheck.node.whitePapersAndEbooks.resourceType === 'finance-how-to' ? <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources/finance-how-to`} external="no" /> :
                                                                            <ResourceCard blogItem={resourceItemCheck} index={index} url={`resources`} external="no" />}
                                            </>
                                        </React.Fragment>
                                    ))}
                                </Slider>
                            )}
                        </div>
                        <div className="l--mobile">
                            {process.env.GATSBY_LANG === "de" ?
                                <Link to="/resources" className="l-button">
                                    Alle Ressourcen ansehen
                                </Link>
                                :
                                <Link to="/resources" className="l-button">
                                    View All Resources
                                </Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllRelatedResourcesComponent;